import React from "react";
import type { Dayjs } from "dayjs";
import { Calendar } from "antd";
import type { CalendarProps } from "antd";

export default function ApptCalendar(props: {
  setDate: (d: Date) => void;
  date: Date;
}) {
  const { setDate } = props;

  const onPanelChange = (
    _value: Dayjs,
    _mode: CalendarProps<Dayjs>["mode"]
  ) => {};

  const handleChange = (date: Dayjs) => {
    setDate(new Date(date.toDate()));
  };

  return (
    <div className="lg:h-full p-4">
      <Calendar
        fullscreen={false}
        onChange={handleChange}
        onPanelChange={onPanelChange}
        className="appt-calendar-modern"
      />
    </div>
  );
}
